export const fmtNum = (n, digits = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "--";
  return Number(n).toLocaleString("en-IN", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

export const fmtCurrency = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "--";
  const sign = n < 0 ? "-" : n > 0 ? "+" : "";
  return `${sign}₹${fmtNum(Math.abs(n), 2)}`;
};

export const pnlClass = (n) => {
  if (!n || n === 0) return "text-slate-300";
  return n > 0 ? "text-emerald-400" : "text-rose-400";
};

export const pnlBgClass = (n) => {
  if (!n || n === 0) return "";
  return n > 0 ? "bg-emerald-500/10 text-emerald-400" : "bg-rose-500/10 text-rose-400";
};

